namespace Gamification.Gamification {
    export interface ProdottiEsperienzeClassiForm {
        IdProdottoEsperienza: Serenity.IntegerEditor;
        IdProdottoClasse: Serenity.IntegerEditor;
    }

    export class ProdottiEsperienzeClassiForm extends Serenity.PrefixedContext {
        static formKey = 'Gamification.ProdottiEsperienzeClassi';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ProdottiEsperienzeClassiForm.init)  {
                ProdottiEsperienzeClassiForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;

                Q.initFormType(ProdottiEsperienzeClassiForm, [
                    'IdProdottoEsperienza', w0,
                    'IdProdottoClasse', w0
                ]);
            }
        }
    }
}
